import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-calendar/dist/Calendar.css";
import RadioButtons from "../elements/RadioButtons";
import DatesContainer from "../elements/DatesContainer";

function CreateYourPageForm({
  target,
  setTarget,
  customTarget,
  setCustomTarget,
  isEmpty,
  campaignTitle,
  setCampaignTitle,
  day,
  month,
  year,
  setDay,
  setMonth,
  setYear,
}) {

  return (
    <div>
      <div>
        <p className="subheader">TELL US YOUR FUNDRAISING GOALS</p>
        <p className="text-body">
          We would love to hear all about your fundraising plans below.
        </p>
      </div>
      <div>
        <p className="subheader2 mt-4">NAME YOUR FUNDRAISING PAGE</p>
      </div>
      <div>
        <div className="mb-4">
          <input
            className={`input inputStyle campaign-input mt-3 ${
              isEmpty && campaignTitle === "" ? "emptyInput" : ""
            }`}
            rows="5"
            placeholder="Type here..."
            value={campaignTitle}
            onChange={(e) => setCampaignTitle(e.target.value)}
          />
        </div>
      </div>
      <div>
        <div className="mb-2">
          <p className="subheader2 mt-4">SET FUNDRAISING TARGET</p>
          <p className="text-body2">How much are you hoping to raise?</p>
        </div>
        <RadioButtons
          target={target}
          setTarget={setTarget}
          setCustomTarget={setCustomTarget}
        />
        <div className="field mb-4 mt-3">
          <p className="control has-icons-left">
            <input
              className={`input inputStyle campaign-input`}
              type="number"
              placeholder="Custom"
              value={customTarget}
              onChange={(e) => setCustomTarget(e.target.value)}
            />
            <span
              className="icon is-small is-left"
              style={{ color: "black", size: "26px", lineHeight: "36px" }}
            >
              £
            </span>
          </p>
        </div>
        <div className="mb-2">
          <p className="subheader2 mt-4">
            <span className="has-text-weight-bold">
              DO YOU HAVE A DATE FOR YOUR FUNDRAISING ACTIVITY?
            </span>
            <span style={{ fontWeight: "normal", marginLeft: "5px" }}>
              (OPTIONAL)
            </span>
          </p>
        </div>

        <DatesContainer
          isEmpty={isEmpty}
          day={day}
          month={month}
          year={year}
          setDay={setDay}
          setMonth={setMonth}
          setYear={setYear}
        />
      </div>
    </div>
  );
}

export default CreateYourPageForm;
